import styled, { css } from 'styled-components'

import { Color } from 'constants/color'

export const Wrapper = styled.div`
    button {
        width: 40px;
        height: 40px;
        margin: 0 4px;
        cursor: pointer;

        ${props =>
            props.disabled &&
            css`
                pointer-events: none;
                cursor: not-allowed;
                opacity: 0.7;
            `}
        border-radius: 50%;

        background: transparent;
        border: none;

        ${props =>
            props.isActive &&
            css`
                background: ${Color.transparentBlack};
                border: 1px solid ${Color.unknownColor23};
            `}
    }
`
